import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import apiCall from "../AuthorizedApi";
import { getHostUrl } from "../getHostUrl";
import { apiUrls } from "../../../config/msg91Urls";

export const loginUser = createAsyncThunk(
    'auth/loginUser',
    async (credentials: { phone_number: string, country_code: string }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${getHostUrl()}/account/sendotp_v2/`, credentials, {
            });
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

// export const loginUser = createAsyncThunk(
//     "auth/loginUser",
//     async (payload: { phone_number: string }, { rejectWithValue }) => {
//         try {
//             const body = {
//                 identifier: payload.phone_number,  // +91XXXXXX
//                 widgetId: "356b72686b4e353737393137",
//                 tokenAuth: "469409TsVeAOUHs691c1efcP1",
//             };

//             const res = await axios.post(apiUrls.sendOTP, body, {
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Accept": "application/json",
//                 },
//             });

//             return res.data;  // MSG91 response
//         } catch (error: any) {
//             return rejectWithValue(error.response?.data || "Something went wrong");
//         }
//     }
// );

export const verifyOTP = createAsyncThunk(
    'auth/verifyOTP',
    async (credentials: { country_code: string, phone_number: string, otp: string, orderId: string }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${getHostUrl()}/account/login_v2/`, credentials);
            // console.log(response.data);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

// export const verifyOTP = async (
//     credentials: { phone_number: string; country_code: string; otp: string; orderId: string }
// ) => {
//     try {
//         const payload = {
//             otp: credentials.otp,
//             reqId: credentials.orderId,
//             widgetId: "356b72686b4e353737393137",
//             tokenAuth: "469409TsVeAOUHs691c1efcP1",

//         };

//         const res = await axios.post(apiUrls.verifyOTP, payload, {
//             headers: {
//                 "Content-Type": "application/json",
//                 Accept: "application/json",

//             },
//         });

//         return res.data;
//     } catch (error: any) {
//         throw error;
//     }
// }

export const userVerification = createAsyncThunk(
    'auth/userVerification',
    async (data: { phone_number: string, country_code: string }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${getHostUrl()}/account/api/UserVerify/`, data);
            // // console.log(response);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const getUserByToken = createAsyncThunk<any, number | null | void>(
    'auth/getUserByToken',
    async (branchId, { rejectWithValue }) => {
        try {
            let activeBranchId: string | number | null = null;
            if (branchId !== undefined) {
                activeBranchId = branchId;
                if (branchId === null) {
                    localStorage.removeItem('selected_branch_id');
                } else {
                    localStorage.setItem('selected_branch_id', String(branchId));
                }
            } else {
                activeBranchId = localStorage.getItem('selected_branch_id');
            }

            const query = activeBranchId ? `?branch_id=${activeBranchId}` : '';
            try {
                const response = await apiCall({
                    method: 'GET',
                    url: `/account/user-details_v2/${query}`
                });
                // apiCall already returns axios response.data; keep inner .data if wrapped
                return response?.data ?? response;
            } catch (fetchErr: any) {
                // If fetching user details with a cached branch_id fails (e.g. 403 assigned branch mismatch or 400 invalid branch),
                // remove stale branch_id from localStorage and retry without query param so the user can load their account with latest assigned branch
                if (activeBranchId && (fetchErr?.response?.status === 403 || fetchErr?.response?.status === 400)) {
                    localStorage.removeItem('selected_branch_id');
                    const retryResponse = await apiCall({
                        method: 'GET',
                        url: '/account/user-details_v2/'
                    });
                    return retryResponse?.data ?? retryResponse;
                }
                throw fetchErr;
            }
        } catch (error: any) {
            return rejectWithValue(error?.response?.data || error?.message || 'Failed to fetch user details');
        }
    }
);

export const resendOTP = createAsyncThunk(
    'auth/resendOTP',
    async (credentials: { orderId: string, country_code: string }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${getHostUrl()}/account/resent-otp_v2/`, credentials);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response.data);
        }
    }
);

// export const resendOTP = createAsyncThunk(
//     "auth/resendOTP",
//     async ({ orderId }: { orderId: string }, { rejectWithValue }) => {
//         try {
//             const body = {
//                 reqId: orderId,
//                 retrytype: "text",
//                 widgetId: "356b72686b4e353737393137",
//                 tokenAuth: "469409TsVeAOUHs691c1efcP1",
//             };

//             const res = await axios.post(apiUrls.retryOTP, body, {
//                 headers: {
//                     "Content-Type": "application/json",
//                     Accept: "application/json",
//                 },
//             });

//             return res.data;
//         } catch (error: any) {
//             return rejectWithValue(error.response?.data || "Something went wrong");
//         }
//     }
// );

